import { OpeningHours } from './OpeningHours';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class LoadProfile {

  public annualAverageSiteConsumption: number | null = null;
  public hasMonthlyAverageSiteConsumption: boolean | null = null;
  public monthlyAverageSiteConsumption: number[] | null = null;

  public hasDifferentLoadProfileAfter: boolean | null = null;

  public profileBeforeHasSameConsumptionAllDayLong: boolean | null = null;
  public profileBeforeNightConsumptionPercentage: number | null = null;
  public profileBeforeOpeningHours: OpeningHours | null = null;

  public profileAfterHasSameConsumptionAllDayLong: boolean | null = null;
  public profileAfterNightConsumptionPercentage: number | null = null;
  public profileAfterOpeningHours: OpeningHours | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.profileBeforeOpeningHours = this.profileBeforeOpeningHours ? new OpeningHours(this.profileBeforeOpeningHours) : null;

    this.profileAfterOpeningHours = this.profileAfterOpeningHours ? new OpeningHours(this.profileAfterOpeningHours) : null;
  }

}
